// 도(degree)를 라디안(radian)으로 변환하는 함수
const deg2rad = (deg) => {
  return deg * (Math.PI / 180);
};

const haversine = (pos1, pos2) => {
  const R = 6371; // 지구의 반지름 (단위: km)
  const dLat = deg2rad(parseFloat(pos2.lat2) - pos1.lat1); // 두 위도 간의 차이를 라디안으로 변환
  const dLon = deg2rad(parseFloat(pos2.lng2) - pos1.lng1); // 두 경도 간의 차이를 라디안으로 변환
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(pos1.lat1)) *
      Math.cos(deg2rad(pos2.lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c; // 두 지점 간의 거리 (단위: km)
  return distance;
};

export { haversine };
